import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";

// UI
import P from "../paragraph";

function CodeEditor({
  name,
  block,
  label,
  isError,
  errors,
  className,
  labelClassName,
  codeEditorGroupClassName,
  value,
  handleChange
}) {
  const editorClasses = classNames(
    "code-editor",
    {
      block,
      /* Ошибка при валидации */
      error: isError || (errors && errors.length)
    },
    className
  );

  const editorGroupClasses = classNames(
    "code-editor--group",
    {},
    codeEditorGroupClassName
  );

  /* LABEL */
  let LabelElement = null;
  if (label) {
    const labelClasses = classNames("label", labelClassName);

    LabelElement = React.createElement(
      "label",
      { htmlFor: name, className: labelClasses },
      label
    );
  }

  /* EDITOR */
  let EditorElement = React.createElement(Editor, {
    className: editorClasses,
    value,
    onValueChange: code => handleChange(code),
    highlight: code => highlight(code, languages.js),
    padding: 10
  });

  /* ERRORS */
  let errorsMessages = null;
  if (errors && errors.length > 0) {
    errorsMessages = errors.map(error =>
      React.createElement(
        P,
        { size: "x-small", margin: "no", key: error },
        error
      )
    );
  }
  const errorClasses = classNames("code-editor--errors", {
    /* Ошибка при валидации */
    error: errors && errors.length > 0
  });
  const ErrorsElement = React.createElement(
    "div",
    { className: errorClasses },
    errorsMessages
  );

  return React.createElement(
    "div",
    { className: editorGroupClasses },
    LabelElement,
    EditorElement,
    ErrorsElement
  );
}

CodeEditor.defaultProps = {
  className: null,
  labelClassName: null,
  codeEditorGroupClassName: null,
  name: null,
  block: false,
  disabled: false,
  handleChange: null,
  label: null,
  errors: null,
  isError: false
};

CodeEditor.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  codeEditorGroupClassName: PropTypes.string,
  name: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  isError: PropTypes.bool
};

export default CodeEditor;
